module.exports = __webpack_public_path__ + "static/media/fly.6eaba97c.svg";